<div>
    <p ng-if="$ctrl.templates.length === 0">{{'admin.workflowConfig.visibleReportTemplates.empty'|translate}}</p>
    <ul>
        <li ng-repeat="template in $ctrl.templates track by $index">
            <div class="template-link-text">
                <span class="template-name">
                    <a ng-click="$ctrl.editTemplate(template)">{{template.Docflow.Title}} ({{template.Docflow.FullRegistrationNumber}})</a>
                </span>
                <span class="remove-template">
                    <a ng-click="$ctrl.deleteTemplate(template)">{{'admin.workflowConfig.reportTemplates.remove'|translate}}</a>
                </span>
            </div>
        </li>
    </ul>
</div>